module.exports = __webpack_public_path__ + "img/future.67417050.jpg";